const MetricSeries = Object.freeze({
  TOTAL_BUZZ: 'TotalBuzz',
  TOTAL_BUZZ_POST: 'TotalBuzzPost',
  TOTAL_REPLIES: 'TotalReplies',
  TOTAL_REPOSTS: 'TotalReposts',
  ORIGINAL_POSTS: 'OriginalPosts',
  POST_VIDEOS: 'PostVideos',
  POST_VIDEOS_OR_IMAGES: 'PostVideosOrImages',
  POST_IMAGES: 'PostImages',
  POST_OTHER: 'PostOther',
  ENGAGEMENTS: 'Engagements',
  COMMENTS: 'Comments',
  LIKES: 'Likes',
  SHARES: 'Shares',
  DISLIKES: 'Dislikes',
  VIEWS: 'Views',
  SCORE: 'Score',
  ENGAGEMENT_ON_ORIGINAL_POSTS: 'EngagementOnOriginalPosts',
  SUPPORTED_ORIGINAL_POSTS: 'SupportedOriginalPosts',
  ENGAGEMENT_RATIO: 'EngagementRatio',
  ENGAGEMENT_RATIO_ONLY: 'EngagementRatioOnly',
  TOP_LINKS: 'TopLinks',
  IMPRESSIONS: 'Impressions',
  LIKE_PASSION: 'LikePassion',
  NOT_LIKE_PASSION: 'NotLikePassion',
  HATE_PASSION: 'HatePassion',
  LOVE_PASSION: 'LovePassion',
  POSITIVE_SENTIMENT: 'PositiveSentiment',
  NEGATIVE_SENTIMENT: 'NegativeSentiment',
  NEUTRAL_SENTIMENT: 'NeutralSentiment',
  POSITIVE_SENTIMENT_SCORE: 'PositiveSentimentScore',
  NEGATIVE_SENTIMENT_SCORE: 'NegativeSentimentScore',
  NET_SENTIMENT: 'NetSentiment',
  PASSION: 'Passion',
  STRONG_EMOTION: 'StrongEmotion',
  WEAK_EMOTION: 'WeakEmotion',
  SOURCE_BLOGS: 'SourceBlogs',
  SOURCE_COMMENTS: 'SourceComments',
  SOURCE_CONSUMER_REVIEWS: 'SourceConsumerReviews',
  SOURCE_FORUMS: 'SourceForums',
  SOURCE_MICROBLOGS: 'SourceMicroblogs',
  SOURCE_NEWS: 'SourceNews',
  SOURCE_BLUESKY: 'SourceBluesky',
  SOURCE_REDDIT: 'SourceReddit',
  SOURCE_BROADCAST: 'SourceBroadcast',
  SOURCE_PODCAST: 'SourcePodcast',
  SOURCE_OTHER: 'SourceOther',
  SOURCE_PROF_REVIEWS: 'SourceProfReviews',
  SOURCE_SOCIAL_NETWORKS: 'SourceSocialNetworks',
  SOURCE_TWITTER: 'SourceTwitter',
  SOURCE_INTERNAL: 'SourceInternal',
  SOURCE_FACEBOOK: 'SourceFacebook',
  SOURCE_INSTAGRAM: 'SourceInstagram',
  SOURCE_YOU_TUBE: 'SourceYouTube',
  SOURCE_TIKTOK: 'SourceTikTok',
  SOURCE_BLOGS_POSTS: 'SourceBlogsPosts',
  SOURCE_COMMENTS_POSTS: 'SourceCommentsPosts',
  SOURCE_CONSUMER_REVIEWS_POSTS: 'SourceConsumerReviewsPosts',
  SOURCE_FORUMS_POSTS: 'SourceForumsPosts',
  SOURCE_MICROBLOGS_POSTS: 'SourceMicroblogsPosts',
  SOURCE_NEWS_POSTS: 'SourceNewsPosts',
  SOURCE_BROADCAST_POSTS: 'SourceBroadcastPosts',
  SOURCE_PODCAST_POSTS: 'SourcePodcastPosts',
  SOURCE_BLUESKY_POSTS: 'SourceBlueskyPosts',
  SOURCE_REDDIT_POSTS: 'SourceRedditPosts',
  SOURCE_OTHER_POSTS: 'SourceOtherPosts',
  SOURCE_PROF_REVIEWS_POSTS: 'SourceProfReviewsPosts',
  SOURCE_SOCIAL_NETWORKS_POSTS: 'SourceSocialNetworksPosts',
  SOURCE_TWITTER_POSTS: 'SourceTwitterPosts',
  SOURCE_INTERNAL_POSTS: 'SourceInternalPosts',
  SOURCE_FACEBOOK_POSTS: 'SourceFacebookPosts',
  SOURCE_INSTAGRAM_POSTS: 'SourceInstagramPosts',
  SOURCE_YOU_TUBE_POSTS: 'SourceYouTubePosts',
  SOURCE_TIKTOK_POSTS: 'SourceTikTokPosts',
  NON_SCALED_UNIQUE_AUTHORS: 'NonScaledUniqueAuthors',
  SCALED_UNIQUE_AUTHORS: 'ScaledUniqueAuthors',
  UNIQUE_AUTHORS: 'UniqueAuthors',
  OVERALL_STAR_RATINGS: 'OverallStarRatings',
  OVERALL_SURVEY_SCORES: 'OverallSurveyScores',
  NET_PROMOTER_SCORES: 'NetPromoterScores',
  OVERALL_STAR_RATINGS_TOTAL: 'OverallStarRatingsTotal',
  OVERALL_SURVEY_SCORES_TOTAL: 'OverallSurveyScoresTotal',
  OVERALL_STAR_RATINGS_TOTAL_POST: 'OverallStarRatingsTotalPost',
  OVERALL_SURVEY_SCORES_TOTAL_POST: 'OverallSurveyScoresTotalPost',
  OVERALL_STAR_RATINGS_AVERAGE: 'OverallStarRatingsAverage',
  OVERALL_SURVEY_SCORES_AVERAGE: 'OverallSurveyScoresAverage',
  INSTAG_ADMIN_POSTS: 'InstagAdminPosts',
  YOU_TUBE_POSTS: 'YouTubePosts',
  TOTAL_ENGAGEMENTS: 'TotalEngagements',
  POST_IMPRESSIONS: 'PostImpressions',
  POSITIVE_SENTIMENT_ON_SCALED_UNIQUE_AUTHORS: 'PositiveSentimentOnScaledUniqueAuthors',
  POSITIVE_SENTIMENT_ON_NON_SCALED_UNIQUE_AUTHORS: 'PositiveSentimentOnNonScaledUniqueAuthors',
  POSITIVE_SENTIMENT_ON_UNIQUE_AUTHORS: 'PositiveSentimentOnUniqueAuthors',
  NEGATIVE_SENTIMENT_ON_SCALED_UNIQUE_AUTHORS: 'NegativeSentimentOnScaledUniqueAuthors',
  NEGATIVE_SENTIMENT_ON_NON_SCALED_UNIQUE_AUTHORS: 'NegativeSentimentOnNonScaledUniqueAuthors',
  NEGATIVE_SENTIMENT_ON_UNIQUE_AUTHORS: 'NegativeSentimentOnUniqueAuthors',
  NET_SENTIMENT_ON_UNIQUE_AUTHORS: 'NetSentimentOnUniqueAuthors',
  LOVE_PASSION_ON_SCALED_UNIQUE_AUTHORS: 'LovePassionOnScaledUniqueAuthors',
  LOVE_PASSION_ON_NON_SCALED_UNIQUE_AUTHORS: 'LovePassionOnNonScaledUniqueAuthors',
  HATE_PASSION_ON_SCALED_UNIQUE_AUTHORS: 'HatePassionOnScaledUniqueAuthors',
  HATE_PASSION_ON_NON_SCALED_UNIQUE_AUTHORS: 'HatePassionOnNonScaledUniqueAuthors',
  LIKE_PASSION_ON_SCALED_UNIQUE_AUTHORS: 'LikePassionOnScaledUniqueAuthors',
  LIKE_PASSION_ON_NON_SCALED_UNIQUE_AUTHORS: 'LikePassionOnNonScaledUniqueAuthors',
  NOT_LIKE_PASSION_ON_SCALED_UNIQUE_AUTHORS: 'NotLikePassionOnScaledUniqueAuthors',
  NOT_LIKE_PASSION_ON_NON_SCALED_UNIQUE_AUTHORS: 'NotLikePassionOnNonScaledUniqueAuthors',
  PASSION_ON_UNIQUE_AUTHORS: 'PassionOnUniqueAuthors'
})
export default MetricSeries
export type MetricSeriesStrings = typeof MetricSeries[keyof typeof MetricSeries]
// RESERVE BELOW
